var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-airforce.1e7311b1.png","uri@2x": __webpack_public_path__ + "icon-airforce.aea845a9.png","uri@3x": __webpack_public_path__ + "icon-airforce.6c2c46c5.png",
    width: 32,
    height: 29
});